<template>
  <div class="sm-page-content" :class="[`sm-page-${pageShortname}`]" v-if="page">
    <h1 v-show="!hideTitle">{{pageTitle}}</h1>
    <slot name="beforeArticle"></slot>
    <article v-html="pageDescriptionGeneratedHtml"></article>
    <slot></slot>
  </div>
  
  <vue-easy-lightbox
    :visible="visibleRef"
    :imgs="imgsRef"
    :index="indexRef"
    @hide="onHide"
  ></vue-easy-lightbox>
</template>
<script>
  
import { computed, watch, ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useFrontDataStore } from '../stores/front';
import setMeta from '../misc/setMeta';
import useIsMobile from '../misc/useIsMobile';
import isOldMiam from '../misc/isOldMiam';
import { getSeoPath, toSeoPath } from '../misc/seoPath';


import VueEasyLightbox from 'vue-easy-lightbox'


export default {
  name: "GenericPage",
  props: {
    pageShortname: {
      type: String,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    isMobileEdit: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    descriptionHtml: {
      type: String,
    },
    fromAdmin: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const frontDataStore = useFrontDataStore();
    const { pages } = storeToRefs(frontDataStore);
    const page = computed(() => pages.value[props.pageShortname] || {});    
    const router = useRouter();
    
    watch(page, function() {
      let metaTitle = page.value.metaTitle;
      let metaDescription = page.value.metaDescription;

      const seoPath = getSeoPath(props.pageShortname);
      const pagePath = seoPath || router.resolve({
        name: props.pageShortname, 
        params: {}
      }).fullPath;
      const routeFoodMenu = `${document.location.protocol}//${document.location.host}${pagePath}`;

      setMeta({
        title: metaTitle, 
        description: metaDescription, 
        canIndex: true,
        ogUrl: routeFoodMenu,
      });

      if(!props.fromAdmin && isOldMiam() && page.value.title && !page.value.descriptionHtml) {
        document.location = `https://www.faimdesaison.fr${pagePath}`;
        return;
      }
    }, {deep: true, immediate: true});

    
    const visibleRef = ref(false)
    const indexRef = ref(0) // default 0
    const imgsRef = ref([]);
    
    visibleRef.value = false;

    imgsRef.value = [];
    indexRef.value = 0;

    const onHide = () => (visibleRef.value = false)
    const onPictureClicked = (evt) => {
      //const src = evt.srcElement.src;
      const altSrc = evt.srcElement.getAttribute('data-altsrc');
      const ix = imgsRef.value.findIndex(i => i == altSrc);
      indexRef.value = ix;
      visibleRef.value = true;
    };

    const transformHtml = () => {
      setImagesEvent();
      setButtonColor();
      setLinkTarget();
      setLinkHandler();
    };

    const setLinkTarget = () => {
      const as = document.querySelectorAll('a[target]');
      as.forEach(a => {
        if(a.href.indexOf(document.location.host) >= 0 || a.href.indexOf('miam-vercors.com') >= 0 || a.href.indexOf('faimdesaison.fr') >= 0) {
          a.removeAttribute('target');
          if(a.href.indexOf('miam-vercors.com') >= 0 || a.href.indexOf('faimdesaison.fr') >= 0) {
            // remove host, keep only path
            let path = a.href.replace(/^https?:\/\/[^/]+/, '');
            path = toSeoPath(path);
            a.href = path;
            a.onclick = function(evt) {
              evt.preventDefault();
              router.push(path);
            };
          }
        }
      });
    };

    const setLinkHandler = () => {
      const as = document.querySelectorAll('a.js-openNewsletterRegister');
      as.forEach(a => {
        a.addEventListener('click', (evt) => {
          evt.preventDefault();
          document.querySelector('.js-subscribeToNewsletter').click();
        });
      });
      const ws = document.querySelectorAll('a.js-openWhatsApp');
      ws.forEach(w => {
        w.addEventListener('click', (evt) => {
          evt.preventDefault();
          document.querySelector('.js-whatsApp').click();
        });
      });
    };

    const setButtonColor = () => {
      const buttons = document.querySelectorAll('.PlaygroundEditorTheme__h6');
      buttons.forEach(button => {
        const elementWithColor = button.querySelector('[style*="background-color"]');
        const color = elementWithColor ? elementWithColor.style.backgroundColor : null;
        button.style.backgroundColor = color;
      });
      {
        const containers = document.querySelectorAll('div[data-grid-template-columns="3fr 2fr 0fr"],div[data-grid-template-columns="2fr 3fr 0fr"]');
        containers.forEach(container => {
          const elementWithColor = container.querySelector('.PlaygroundEditorTheme__h7 [style*="background-color"]');
          const color = elementWithColor ? elementWithColor.style.backgroundColor : null;
          
          if(color) {
            container.style.backgroundColor = color;
          }else{
            container.style.backgroundColor = 'none';
            container.classList.add('no-background-color');
          }
        });
      }
      {
        const containers = document.querySelectorAll('div[data-grid-template-columns="1fr 1fr 1fr 1fr"] > div.PlaygroundEditorTheme__layoutItem');
        containers.forEach(container => {
          const elementWithColor = container.querySelector('.PlaygroundEditorTheme__h7 [style*="background-color"]');
          const color = elementWithColor ? elementWithColor.style.backgroundColor : null;
          container.style.backgroundColor = color;
        });
      }
    };

    const setImagesEvent = () => {
      
      const imgElms = document.querySelectorAll('.PlaygroundEditorTheme__paragraph img');
      imgElms.forEach(imgElm => {
        const parent = imgElm.parentElement;
          if (parent) {
            parent.classList.add('PlaygroundEditorTheme__paragraph__withPicture');
          }
      });


      const elms = document.querySelectorAll('.sm-page-prestations .lightbox-img,.lightbox-img.zoom,img[data-zoomable="1"]');
      let imagesSrc = [...elms].map((e)=> {
        let altSrc = e.getAttribute('data-altsrc');
        if(!altSrc) {
          altSrc = e.getAttribute('src').replace('.jpg', '-full.jpg');
          e.setAttribute('data-altsrc', altSrc);
        }
        return altSrc;
      });
      
      [...elms].forEach(elm => {
        if(elm.classList.contains('inited')) {
          return;
        }
        elm.classList.add('inited');
        elm.addEventListener('click', onPictureClicked);
        elm.addEventListener('touch', onPictureClicked);
      });
      imgsRef.value = imagesSrc;
    }
    onMounted(() => {
      setTimeout(transformHtml, 100);
      setTimeout(transformHtml, 1000);
      setTimeout(transformHtml, 2000);
      setTimeout(transformHtml, 3000);
      setTimeout(transformHtml, 10000);
    });


    const isMobile = useIsMobile();
    const shouldLoadMobile = computed(() => props.isMobileEdit || isMobile.value);

    var pageTitle = computed(() => (props.title || page.value.title));
    var pageDescriptionGeneratedHtml = computed(() => {
      if(shouldLoadMobile.value) {
        const el = (props.descriptionMobileHtml || page.value.descriptionMobileGeneratedHtml || page.value.descriptionGeneratedHtml); 
        if(el) {
          return el;
        }
      }
      return (props.descriptionHtml || page.value.descriptionGeneratedHtml);
      });
    
    watch(pageDescriptionGeneratedHtml, () => {
      setTimeout(transformHtml, 100);
      setTimeout(transformHtml, 1000);
    });
    
    return {
      page: page,
      pageTitle,
      pageDescriptionGeneratedHtml,
      visibleRef,
      indexRef,
      imgsRef,
      onHide,
      onPictureClicked,
    };
  },
  components: {
    VueEasyLightbox,
  },
};
</script>